<script setup lang="ts">
import EnvironmentDeprecationBanner from "../common/components/EnvironmentDeprecationBanner.vue";
import { WHITE_MWS_LOGO_URL } from "../common/utils/constants";
</script>

<template>
  <main class="bg-white min-h-screen">
    <EnvironmentDeprecationBanner />
    <div
      class="flex items-center h-16 shrink-0 px-4 bg-gray-700 sticky top-0 z-20"
    >
      <img
        class="h-8"
        :src="WHITE_MWS_LOGO_URL"
        alt="MWS"
      />
    </div>
    <RouterView />
  </main>
</template>
